<div class="prompt-dialog">
    <h2 mat-dialog-title>{{ data.title }}</h2>

    <mat-dialog-content>
        <p class="mb-4">{{ data.message }}</p>

        <mat-form-field class="w-full">
            <mat-label>{{ data.placeholder || 'Enter text' }}</mat-label>
            <input matInput [formControl]="inputControl" [placeholder]="data.placeholder" (keydown)="onKeyDown($event)" cdkFocusInitial>
            <mat-error *ngIf="inputControl.hasError('required')">
                This field is required
            </mat-error>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions class="flex justify-end gap-2">
        <button mat-button (click)="onCancel()">
            Cancel
        </button>
        <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="inputControl.invalid">
            Confirm
        </button>
    </mat-dialog-actions>
</div>